import * as CartService from '../services/CartService'

export const ADD_ITEM_REQUEST = 'ADD_ITEM_REQUEST';
export const ADD_ITEM_SUCCESS = 'ADD_ITEM_SUCCESS';
export const ADD_ITEM_FAILURE = 'ADD_ITEM_FAILURE';

export function addItemRequest() {
    return {
        type: ADD_ITEM_REQUEST
    }
}

export function addItemSuccess(payload) {
    return {
        type: ADD_ITEM_SUCCESS,
        payload
    }
}

export function addItemFailure(payload) {
    return {
        type: ADD_ITEM_FAILURE,
        payload
    }
}

export function addItem(identifier) {
    return (dispatch) => {
        dispatch(addItemRequest());

        CartService.addItem(identifier)
            .then(response => {
                dispatch(addItemSuccess(response));
            })
            .catch(error => {
                dispatch(addItemFailure(error));
            });
    }
}
